// 账号留存
import request from '@/utils/request';
export function accountRetain(data) {
  return request({
    url: '/data/accountretain',
    method: 'get',
    params: data
  });
} //服务器角色留存

export function serverRetentionByTier(data) {
  return request({
    url: '/data/serverRetentionByTier',
    method: 'get',
    params: data
  });
}
export function serverRetentionByTierDetail(data) {
  return request({
    url: '/data/serverRetentionByTierDetail',
    method: 'get',
    params: data
  });
}
export function accountOrDeviceRetainDetail(data) {
  return request({
    url: '/data/accountOrDeviceRetainDetail',
    method: 'get',
    params: data
  });
}
export function tierRetentionDetailCurrency(data) {
  return request({
    url: '/data/tierRetentionDetailCurrency',
    method: 'get',
    params: data
  });
}
export function tierRetentionDetail(data) {
  return request({
    url: '/data/tierRetentionDetail',
    method: 'get',
    params: data
  });
}